export default "__VITE_ASSET__CxedneOx__"